'use client';

import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

export default function Footer() {
  return (
    <footer className="relative z-10 bg-white pt-16 pb-8 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Struktur Grid Footer */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-12 w-full mb-12">
          {/* 1. KOLOM KIRI (Logo & Deskripsi) */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-4">
              <Link href="/" className="flex items-center gap-2 group">
                <Image
                  src="/assets/images/no_image.png"
                  alt="Logo IndoCuttingLaser"
                  width={220}
                  height={80}
                  className="w-auto h-12 md:h-16 object-contain transition-transform group-hover:scale-105"
                  priority
                />
                <span className="font-bold text-2xl text-black flex items-center gap-1">
                  IndoCutting
                  <span className="text-orange-500">Laser</span>
                </span>
              </Link>
            </div>
            <p className="text-gray-600 mb-6 text-sm pr-4 leading-relaxed">
              Solusi fabrikasi lengkap di Bekasi, Jawa Barat. Melayani jasa laser cutting, ACP dan
              CNC router presisi tinggi untuk kebutuhan industri, dekorasi, dan signage di seluruh
              Indonesia.
            </p>

            {/* Icon Sosial Media */}
            <div className="flex gap-4 relative z-20">
              {/* WhatsApp */}
              <a
                href="https://wa.me/628132282297"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 rounded-full bg-white flex items-center justify-center text-[#25D366] hover:bg-[#25D366] hover:text-white transition-all duration-300 border border-gray-200 shadow-sm active:scale-90"
                title="Hubungi kami di WhatsApp"
                aria-label="WhatsApp"
              >
                <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
              </a>

              {/* Facebook */}
              <a
                href="https://www.facebook.com/icetheticjkt"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 rounded-full bg-white flex items-center justify-center text-[#1877F2] hover:bg-[#1877F2] hover:text-white transition-all duration-300 border border-gray-200 shadow-md active:scale-90"
                title="Ikuti kami di Facebook"
                aria-label="Facebook"
              >
                <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>

              {/* Instagram */}
              <a
                href="https://www.instagram.com/cuttinglaserbekasi"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 rounded-full bg-white flex items-center justify-center text-[#E4405F] hover:bg-[#E4405F] hover:text-white transition-all duration-300 border border-gray-200 shadow-md active:scale-90"
                title="Ikuti kami di Instagram"
                aria-label="Instagram"
              >
                <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
                  <path d="M7.75 2C4.574 2 2 4.574 2 7.75v8.5C2 19.426 4.574 22 7.75 22h8.5C19.426 22 22 19.426 22 16.25v-8.5C22 4.574 19.426 2 16.25 2h-8.5zm0 2h8.5C18.322 4 20 5.678 20 7.75v8.5C20 18.322 18.322 20 16.25 20h-8.5C5.678 20 4 18.322 4 16.25v-8.5C4 5.678 5.678 4 7.75 4zm8.75 1a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM12 7a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6z" />
                </svg>
              </a>

              {/* TikTok */}
              <a
                href="https://www.tiktok.com/@indocuttinglaser?_r=1&_t=ZS-97bdaCZtNgL"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 rounded-full bg-white flex items-center justify-center text-black hover:bg-black hover:text-white transition-all duration-300 border border-gray-200 shadow-md active:scale-90"
                title="Ikuti kami di TikTok"
                aria-label="TikTok"
              >
                <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
                  <path d="M19.589 6.686a4.793 4.793 0 01-3.77-4.216V2h-3.193v13.138c0 1.574-1.287 2.857-2.87 2.857-1.584 0-2.871-1.283-2.871-2.857 0-1.573 1.287-2.856 2.87-2.856.294 0 .577.045.844.128V9.154a6.067 6.067 0 00-.844-.061C6.581 9.093 4 11.667 4 14.838 4 18.01 6.581 20.583 9.755 20.583s5.756-2.573 5.756-5.745V8.187a8.01 8.01 0 004.489 1.37V6.686h-.411z" />
                </svg>
              </a>
            </div>
          </div>

          {/* 2. KOLOM TENGAH (Menu Perusahaan) */}
          <div className="md:col-span-3 pt-2">
            <h3 className="text-gray-900 font-bold mb-4 text-lg">Layanan</h3>
            <ul className="space-y-3 text-gray-600 text-sm">
              <li>
                <Link href="/" className="hover:text-orange-600 transition-colors">
                  Beranda
                </Link>
              </li>
              <li>
                <Link href="/about" className="hover:text-orange-600 transition-colors">
                  Tentang Kami
                </Link>
              </li>
              <li>
                <Link href="/gallery" className="hover:text-orange-600 transition-colors">
                  Galeri Workshop
                </Link>
              </li>
              <li>
                <Link href="/contact" className="hover:text-orange-600 transition-colors">
                  Kontak
                </Link>
              </li>
            </ul>
          </div>

          {/* 3. KOLOM KANAN (Google Maps) */}
          <div className="md:col-span-4 flex flex-col w-full md:items-end pt-2">
            <div className="w-full max-w-[320px] relative z-20">
              <h3 className="text-gray-900 font-bold mb-4 text-lg">Lokasi Workshop</h3>
              <div className="w-full h-40 rounded-xl overflow-hidden shadow-sm border border-gray-100 relative group">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.8715255768775!2d106.98581377474996!3d-6.1479517938390575!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e698b0046ba60c9%3A0x4025b9a19297f7ab!2sIndo%20Cutting%20Laser!5e0!3m2!1sid!2sid!4v1778177400671!5m2!1sid!2sid"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen={true}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="transition-all duration-500 group-hover:scale-105"
                ></iframe>
                {/* Overlay Klik Peta */}
                <a
                  href="https://maps.app.goo.gl/BFEvoTXcvsZZciQu8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="absolute inset-0 z-[50] cursor-pointer bg-transparent"
                  title="Buka di Google Maps"
                >
                  <span className="sr-only">Buka Lokasi Indo Cutting Laser di Google Maps</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bagian Bawah Footer (Copyright) */}
        <div className="pt-8 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4 relative z-20">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} IndoCuttingLaser. Hak cipta dilindungi.
          </p>
          <div className="flex gap-6 text-sm text-gray-400">
            <Link href="/privacy" className="hover:text-gray-900 transition-colors">
              Privasi
            </Link>
            <Link href="/terms" className="hover:text-gray-900 transition-colors">
              Syarat & Ketentuan
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
